import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import VerifyResetPasswordComponent from "../../components/Auth/VerifyResetPasswordComponent";

const VerifyResetPasswordPage = () => {
    const navigate = useNavigate();
    const { search } = useLocation();

    let redirect = () => {
        navigate('/dang-nhap.html');
    }

    return <VerifyResetPasswordComponent redirect={ () => redirect() } token={ new URLSearchParams(search).get('token') } />

}

export default VerifyResetPasswordPage;